var React = require('react');

function HalfCircledShape (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"_2-Unknown_1","data-name":"2-Unknown 1","transform":"translate(1.333 1.331)"},[React.createElement("g",{"id":"Group","key":0},React.createElement("path",{"id":"canvas_background","data-name":"canvas background","d":"M0,0H775.6V535.015H0Z","transform":"translate(-1.333 -1.331)","fill":"none"})),React.createElement("g",{"id":"Group-2","data-name":"Group","key":1},React.createElement("g",{"id":"Web"},React.createElement("g",{"id":"_01.Home","data-name":"01.Home"},React.createElement("path",{"id":"section_end","data-name":"section end","d":"M1386.646,724A1688.939,1688.939,0,0,0,1919,638.485V0H0C304.827,437.57,812.224,724,1386.646,724Z","fill":"rgba(0,97,223,0.05)"}))))]));
}

HalfCircledShape.defaultProps = {"width":"1920.333","height":"725.331","viewBox":"0 0 1920.333 725.331"};

module.exports = HalfCircledShape;

HalfCircledShape.default = HalfCircledShape;
